import z from 'zod';

export enum UserPermission {
  ADMIN = 'ADMIN',
  VIP = 'VIP',
  REVIEWER = 'REVIEWER',
  CONTRIBUTOR = 'CONTRIBUTOR',
}

export const userPermissionSchema = z.enum(UserPermission);
